<div class="report-filter-component">
  <div class="report-filter-inner">
    <!-- <div class="filter-pill">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-5%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied?.status }">
            <div class="icon">
              <i class="fal fa-filter"></i>
            </div>

            <div class="filter-text .w-110 text-overflow-ellipsis">
              <span *ngIf="filter?.status?.active && filter?.status?.inActive">
                {{ filterTitle?.status?.all }}
              </span>

              <span *ngIf="filter?.status?.active && !filter?.status?.inActive">
                {{ filterTitle?.status?.active }}
              </span>

              <span *ngIf="!filter?.status?.active && filter?.status?.inActive">
                {{ filterTitle?.status?.inActive }}
              </span>

              <span *ngIf="filter?.status?.active === false && filter?.status?.inActive === false">
                {{ filterTitle?.status?.all }}
              </span>
            </div>
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied?.status"></i>
              <i class="fal fa-times" *ngIf="filterApplied?.status" (click)="clearFilter('status')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-140">
            <div class="filter-option border-bottom-lightest" (click)="onChange('status', 'active')">
              <app-checkbox [isChecked]="filter?.status?.active"> </app-checkbox>
              {{ filterTitle.status?.active }}
            </div>

            <div class="filter-option border-bottom-lightest" (click)="onChange('status', 'inActive')">
              <app-checkbox [isChecked]="filter?.status?.inActive"> </app-checkbox>
              {{ filterTitle?.status?.inActive }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div> -->

        <!-- Language Start -->
        <div class="filter-pill" *ngIf="options?.language">
          <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
            [closeAfterAction]="closeAfterAction" right="0%">
            <ng-template appTemplate="item">
              <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied?.language }">
                <div class="icon">
                  <i class="fal fa-filter"></i>
                </div>
                <div class="filter-text .w-110 text-overflow-ellipsis">
                  
                  <span>
                    Language: {{ filter?.language?.en && filter?.language?.fr ? 'All' : filter?.language?.en ? 'English' : filter?.language?.fr ? 'French' : 'All' }}
                  </span>

                </div>
                <div class="filter-cross">
                  <i class="fal fa-chevron-down" *ngIf="!filterApplied?.language"></i>
                  <i class="fal fa-times" *ngIf="filterApplied?.language" (click)="clearFilter('language')"></i>
                </div>
              </div>
            </ng-template>
    
            <ng-template appTemplate="overlay">
              <div class="filter-overlay w-140">
                <div class="filter-option border-bottom-lightest" (click)="onChange('language', 'en')">
                  <app-checkbox [isChecked]="filter?.language?.en"></app-checkbox>
                  English
                  {{ filterTitle.language?.en }}
                </div>
                
                <div class="filter-option border-bottom-lightest" (click)="onChange('language', 'fr')">
                  <app-checkbox [isChecked]="filter?.language?.fr"></app-checkbox>
                  French
                  {{ filterTitle?.language?.fr }}
                </div>
              </div>
            </ng-template>
          </app-content-overlay>
        </div>
        <!-- Language End -->
    

    <!-- Start Status -->
    <div class="filter-pill" *ngIf="options?.status">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-5%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied?.status }">
            <div class="icon">
              <i class="fal fa-filter"></i>
            </div>

            <div class="filter-text .w-110 text-overflow-ellipsis">
              <span *ngIf="filter?.status?.active && filter?.status?.inActive">
                {{ filterTitle?.status?.all }}
              </span>

              <span *ngIf="filter?.status?.active && !filter?.status?.inActive">
                {{ filterTitle?.status?.active }}
              </span>

              <span *ngIf="!filter?.status?.active && filter?.status?.inActive">
                {{ filterTitle?.status?.inActive }}
              </span>

              <span *ngIf="filter?.status?.active === false && filter?.status?.inActive === false">
                {{ filterTitle?.status?.all }}
              </span>
            </div>
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied?.status"></i>
              <i class="fal fa-times" *ngIf="filterApplied?.status" (click)="clearFilter('status')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-140">
            <div class="filter-option border-bottom-lightest" (click)="onChange('status', 'active')">
              <app-checkbox [isChecked]="filter?.status?.active"> </app-checkbox>
              {{ filterTitle.status?.active }}
            </div>

            <div class="filter-option border-bottom-lightest" (click)="onChange('status', 'inActive')">
              <app-checkbox [isChecked]="filter?.status?.inActive"> </app-checkbox>
              {{ filterTitle?.status?.inActive }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Status -->

    <!-- Start Status -->
    <div class="filter-pill" *ngIf="options?.pricingLogs">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-5%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied?.pricingLogs }">
            <div class="icon">
              <i class="fal fa-filter"></i>
            </div>

            <div class="filter-text .w-110 text-overflow-ellipsis">
              <span *ngIf="filter?.pricingLogs?.company && filter?.pricingLogs?.matrix">
                {{ filterTitle?.pricingLogs?.all }}
              </span>

              <span *ngIf="filter?.pricingLogs?.company && !filter?.pricingLogs?.matrix">
                {{ filterTitle?.pricingLogs?.company }}
              </span>

              <span *ngIf="!filter?.pricingLogs?.company && filter?.pricingLogs?.matrix">
                {{ filterTitle?.pricingLogs?.matrix }}
              </span>

              <span *ngIf="filter?.pricingLogs?.company === false && filter?.pricingLogs?.matrix === false">
                {{ filterTitle?.pricingLogs?.all }}
              </span>
            </div>
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied?.pricingLogs"></i>
              <i class="fal fa-times" *ngIf="filterApplied?.pricingLogs" (click)="clearFilter('pricingLogs')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-140">
            <div class="filter-option border-bottom-lightest" (click)="onChange('pricingLogs', 'company')">
              <app-checkbox [isChecked]="filter?.pricingLogs?.company"> </app-checkbox>
              {{ filterTitle.pricingLogs?.company }}
            </div>

            <div class="filter-option border-bottom-lightest" (click)="onChange('pricingLogs', 'matrix')">
              <app-checkbox [isChecked]="filter?.pricingLogs?.matrix"> </app-checkbox>
              {{ filterTitle?.pricingLogs?.matrix }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Status -->

    <!-- Start Columns -->
    <div class="filter-pill" *ngIf="options?.columns">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-5%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.columns }">
            <!-- Icon -->
            <div class="icon"><i class="fal fa-th"></i></div>

            <!-- Title -->
            <div class="filter-text w-100px text-overflow-ellipsis">
              <span *ngIf="filter?.columns?.selected?.length === 0">Columns</span>
              <span *ngIf="filter?.columns?.selected?.length === 1">{{ (filter?.columns?.selected)[0]?.header }}</span>
              <span *ngIf="filter?.columns?.selected?.length > 1">{{ filterTitle?.columns?.multiple }}</span>
            </div>

            <!-- Clear -->
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.columns"></i>
              <i class="fal fa-times" *ngIf="filterApplied.columns" (click)="clearFilter('columns')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-180 text-overflow-ellipsis">
            <app-multiple-filter scrollHeight="265px" nameField="header" [data]="columns"
              (appChangeFilter)="changeColumnFilter('columns', $event, true)"> </app-multiple-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Columns -->

    <!-- Start PO Item Type -->
    <div class="filter-pill" *ngIf="options?.poType">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-5%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied?.poType }">
            <div class="icon">
              <i class="fal fa-boxes"></i>
            </div>

            <div class="filter-text .w-110 text-overflow-ellipsis">
              <span *ngIf="filter?.poType?.active && filter?.poType?.inActive">
                {{ filterTitle?.poType?.all }}
              </span>

              <span *ngIf="filter?.poType?.active && !filter?.poType?.inActive">
                {{ filterTitle?.poType?.active }}
              </span>

              <span *ngIf="!filter?.poType?.active && filter?.poType?.inActive">
                {{ filterTitle?.poType?.inActive }}
              </span>

              <span *ngIf="filter?.poType?.active === false && filter?.poType?.inActive === false">
                {{ filterTitle?.poType?.all }}
              </span>
            </div>
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied?.poType"></i>
              <i class="fal fa-times" *ngIf="filterApplied?.poType" (click)="clearFilter('poType')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-140">
            <div class="filter-option border-bottom-lightest" (click)="onChange('poType', 'active')">
              <app-checkbox [isChecked]="filter?.poType?.active"> </app-checkbox>
              {{ filterTitle?.poType?.active }}
            </div>

            <div class="filter-option border-bottom-lightest" (click)="onChange('poType', 'inActive')">
              <app-checkbox [isChecked]="filter?.poType?.inActive"> </app-checkbox>
              {{ filterTitle?.poType?.inActive }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End PO Item Type -->

    <!-- Start Restock level -->
    <div class="filter-pill" *ngIf="options?.restockLevel">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-5%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.restockLevel }">
            <div class="icon">
              <i class="fal fa-exclamation-triangle"></i>
            </div>

            <div class="filter-text .w-110 text-overflow-ellipsis">
              <span *ngIf="filter?.restockLevel?.active && filter?.restockLevel?.inActive">
                {{ filterTitle?.restockLevel?.all }}
              </span>

              <span *ngIf="filter?.restockLevel?.active && !filter?.restockLevel?.inActive">
                {{ filterTitle?.restockLevel?.active }}
              </span>

              <span *ngIf="!filter?.restockLevel?.active && filter?.restockLevel?.inActive">
                {{ filterTitle?.restockLevel?.inActive }}
              </span>

              <span *ngIf="filter?.restockLevel?.active === false && filter?.restockLevel?.inActive === false">
                {{ filterTitle?.restockLevel?.all }}
              </span>
            </div>
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.restockLevel"></i>
              <i class="fal fa-times" *ngIf="filterApplied.restockLevel" (click)="clearFilter('restockLevel')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-140">
            <div class="filter-option border-bottom-lightest" (click)="onChange('restockLevel', 'active')">
              <app-checkbox [isChecked]="filter.restockLevel.active"> </app-checkbox>
              {{ filterTitle.restockLevel.active }}
            </div>

            <div class="filter-option border-bottom-lightest" (click)="onChange('restockLevel', 'inActive')">
              <app-checkbox [isChecked]="filter.restockLevel.inActive"> </app-checkbox>
              {{ filterTitle.restockLevel.inActive }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Restock level -->

    <!-- Start Location -->
    <div class="filter-pill" *ngIf="options?.location">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-13%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.location }">
            <div class="icon">
              <i class="fal fa-map-marker-alt"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis">
              <span *ngIf="filter?.location?.selected?.length === 0">{{ filterTitle?.location?.all }}</span>
              <span *ngIf="filter?.location?.selected?.length === 1">{{ (filter?.location?.selected)[0]?.name }}</span>
              <span *ngIf="filter?.location?.selected?.length > 1">{{ filterTitle?.location?.multiple }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.location"></i>
              <i class="fal fa-times" *ngIf="filterApplied.location" (click)="clearFilter('location')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-180 text-overflow-ellipsis">
            <app-multiple-filter scrollHeight="265px" [data]="locations"
              [multipleSearchPlaceholders]="options?.enableMultipleFilterSearch ? options?.multipleSearchPlaceholders : {}"
              [isSearchSelect]="options?.enableMultipleFilterSearch" (appChangeFilter)="changeLocationsFilter($event)">
            </app-multiple-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Location -->

    <!-- Start Service Auth -->
    <div class="filter-pill" *ngIf="options?.serviceAuthStatus">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-13%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.serviceAuthStatus }">
            <div class="icon">
              <i class="fal fa-clipboard-check"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis">
              <span *ngIf="!filter?.serviceAuthStatus?.selected?.length">{{ filterTitle?.serviceAuthStatus?.all
                }}</span>
              <span *ngIf="filter?.serviceAuthStatus?.selected?.length === 1">{{
                (filter?.serviceAuthStatus?.selected)[0]?.name }}</span>
              <span *ngIf="filter?.serviceAuthStatus?.selected?.length > 1">{{ filterTitle?.serviceAuthStatus?.multiple
                }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.serviceAuthStatus"></i>
              <i class="fal fa-times" *ngIf="filterApplied.serviceAuthStatus"
                (click)="clearFilter('serviceAuthStatus')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-180 text-overflow-ellipsis">
            <app-multiple-filter scrollHeight="265px" [data]="serviceAuthOption"
              (appChangeFilter)="changeServiceAuthFilter($event)"> </app-multiple-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Service Auth -->

    <!-- Start Type -->
    <div class="filter-pill" *ngIf="options?.customerFleet">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-3%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied?.customerFleet }">
            <div class="icon">
              <i class="fal fa-user"></i>
            </div>

            <div class="filter-text w-100px text-overflow-ellipsis" [ngClass]="{'w-96px':isFastlapExtraOptions}">
              <span
                *ngIf="(filter?.customerFleet?.fleet && filter?.customerFleet?.regular) || (!filter?.customerFleet?.fleet && !filter?.customerFleet?.regular)">
                {{ filterTitle?.customerFleet?.all }}
              </span>

              <span *ngIf="filter?.customerFleet?.fleet && !filter?.customerFleet?.regular">
                {{ filterTitle?.customerFleet?.fleet }}
              </span>

              <span *ngIf="!filter?.customerFleet?.fleet && filter?.customerFleet?.regular">
                {{ filterTitle?.customerFleet?.regular }}
              </span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.customerFleet"></i>
              <i class="fal fa-times" *ngIf="filterApplied.customerFleet" (click)="clearFilter('customerFleet')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <div class="filter-option border-bottom-lightest" (click)="onChange('customerFleet', 'regular')">
              <app-checkbox [isChecked]="filter?.customerFleet?.regular"> </app-checkbox>
              {{ filterTitle.customerFleet?.regular }}
            </div>

            <div class="filter-option border-bottom-lightest" (click)="onChange('customerFleet', 'fleet')">
              <app-checkbox [isChecked]="filter.customerFleet?.fleet"> </app-checkbox>
              {{ filterTitle.customerFleet?.fleet }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Type -->

    <!-- Start Service Categories -->
    <div class="filter-pill" *ngIf="options?.serviceCategories">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-13%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.serviceCategories }">
            <div class="icon">
              <i class="fal fa-map-marker-alt"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis">
              <span *ngIf="!filter?.serviceCategories?.selected?.length">{{ filterTitle?.serviceCategories?.all
                }}</span>
              <span *ngIf="filter?.serviceCategories?.selected?.length === 1">{{
                (filter?.serviceCategories?.selected)[0]?.name }}</span>
              <span *ngIf="filter?.serviceCategories?.selected?.length > 1">{{ filterTitle?.serviceCategories?.multiple
                }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.serviceCategories"></i>
              <i class="fal fa-times" *ngIf="filterApplied.serviceCategories"
                (click)="clearFilter('serviceCategories')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-180 text-overflow-ellipsis">
            <app-multiple-filter scrollHeight="265px" [data]="serviceCategories"
              (appChangeFilter)="changeServiceCategoriesFilter($event)"> </app-multiple-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Location -->

    <!-- Start stock -->
    <div class="filter-pill" *ngIf="options?.stock">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-5%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.stock }">
            <div class="icon">
              <i class="fal fa-warehouse"></i>
            </div>

            <div class="filter-text .w-110 text-overflow-ellipsis">
              <span *ngIf="filter?.stock?.active && filter?.stock?.inActive">
                {{ filterTitle?.stock?.all }}
              </span>

              <span *ngIf="filter?.stock?.active && !filter?.stock?.inActive">
                {{ filterTitle?.stock?.active }}
              </span>

              <span *ngIf="!filter?.stock?.active && filter?.stock?.inActive">
                {{ filterTitle?.stock?.inActive }}
              </span>

              <span *ngIf="filter?.stock?.active === false && filter?.stock?.inActive === false">
                {{ filterTitle?.stock?.all }}
              </span>
            </div>
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.stock"></i>
              <i class="fal fa-times" *ngIf="filterApplied.stock" (click)="clearFilter('stock')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-140">
            <div class="filter-option border-bottom-lightest" (click)="onChange('stock', 'active')">
              <app-checkbox [isChecked]="filter.stock.active"> </app-checkbox>
              {{ filterTitle.stock.active }}
            </div>

            <div class="filter-option border-bottom-lightest" (click)="onChange('stock', 'inActive')">
              <app-checkbox [isChecked]="filter.stock.inActive"> </app-checkbox>
              {{ filterTitle.stock.inActive }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End stock -->

    <!-- Start Supplier Type -->
    <div class="filter-pill" *ngIf="options?.supplierStatus">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-5%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.supplierStatus }">
            <div class="icon">
              <i class="fal fa-warehouse"></i>
            </div>

            <div class="filter-text .w-110 text-overflow-ellipsis">
              <span *ngIf="filter?.supplierStatus?.internal && filter?.supplierStatus?.online">
                {{ filterTitle?.supplierStatus?.all }}
              </span>
              <span *ngIf="filter?.supplierStatus?.internal && !filter?.supplierStatus?.online">
                {{ filterTitle?.supplierStatus?.internal }}
              </span>
              <span *ngIf="!filter?.supplierStatus?.internal && filter?.supplierStatus?.online">
                {{ filterTitle?.supplierStatus?.online }}
              </span>
              <span *ngIf="filter?.supplierStatus?.internal === false && filter?.supplierStatus?.online === false">
                {{ filterTitle?.supplierStatus?.all }}
              </span>
            </div>
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.supplierStatus"></i>
              <i class="fal fa-times" *ngIf="filterApplied.supplierStatus" (click)="clearFilter('supplierStatus')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-140">
            <div class="filter-option border-bottom-lightest" (click)="onChange('supplierStatus', 'internal')">
              <app-checkbox [isChecked]="filter?.supplierStatus?.internal"> </app-checkbox>
              {{ filterTitle?.supplierStatus?.internal }}
            </div>

            <div class="filter-option border-bottom-lightest" (click)="onChange('supplierStatus', 'online')">
              <app-checkbox [isChecked]="filter?.supplierStatus?.online"> </app-checkbox>
              {{ filterTitle?.supplierStatus?.online }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End stock -->

    <!-- Start Discount Type -->
    <div class="filter-pill" *ngIf="options?.discountType">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-5%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.discountType }">
            <div class="icon">
              <i class="fal fa-warehouse"></i>
            </div>

            <div class="filter-text .w-110 text-overflow-ellipsis">
              <span *ngIf="filter?.discountType?.percentage && filter?.discountType?.dollarValue">
                {{ filterTitle?.discountType?.all }}
              </span>
              <span *ngIf="filter?.discountType?.percentage && !filter?.discountType?.dollarValue">
                {{ filterTitle?.discountType?.percentage }}
              </span>
              <span *ngIf="!filter?.discountType?.percentage && filter?.discountType?.dollarValue">
                {{ filterTitle?.discountType?.dollarValue }}
              </span>
              <span *ngIf="filter?.discountType?.percentage === false && filter?.discountType?.dollarValue === false">
                {{ filterTitle?.discountType?.all }}
              </span>
            </div>
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.discountType"></i>
              <i class="fal fa-times" *ngIf="filterApplied.discountType" (click)="clearFilter('discountType')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-140">
            <div class="filter-option border-bottom-lightest" (click)="onChange('discountType', 'percentage')">
              <app-checkbox [isChecked]="filter?.discountType?.percentage"> </app-checkbox>
              {{ filterTitle?.discountType?.percentage }}
            </div>

            <div class="filter-option border-bottom-lightest" (click)="onChange('discountType', 'dollarValue')">
              <app-checkbox [isChecked]="filter?.discountType?.dollarValue"> </app-checkbox>
              {{ filterTitle?.discountType?.dollarValue }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End stock -->

    <!-- Start Applied Level -->
    <div class="filter-pill" *ngIf="options?.appliedOn">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-5%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.appliedOn }">
            <div class="icon">
              <i class="far fa-calendar-alt"></i>
            </div>

            <div class="filter-text .w-110 text-overflow-ellipsis">
              <span *ngIf="filter?.appliedOn?.orderLevel && filter?.appliedOn?.serviceLevel">
                {{ filterTitle?.appliedOn?.all }}
              </span>
              <span *ngIf="filter?.appliedOn?.orderLevel && !filter?.appliedOn?.serviceLevel">
                {{ filterTitle?.appliedOn?.orderLevel }}
              </span>
              <span *ngIf="!filter?.appliedOn?.orderLevel && filter?.appliedOn?.serviceLevel">
                {{ filterTitle?.appliedOn?.serviceLevel }}
              </span>
              <span *ngIf="filter?.appliedOn?.orderLevel === false && filter?.appliedOn?.serviceLevel === false">
                {{ filterTitle?.appliedOn?.all }}
              </span>
            </div>
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.appliedOn"></i>
              <i class="fal fa-times" *ngIf="filterApplied.appliedOn" (click)="clearFilter('appliedOn')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-140">
            <div class="filter-option border-bottom-lightest" (click)="onChange('appliedOn', 'orderLevel')">
              <app-checkbox [isChecked]="filter.appliedOn.orderLevel"> </app-checkbox>
              {{ filterTitle.appliedOn.orderLevel }}
            </div>

            <div class="filter-option border-bottom-lightest" (click)="onChange('appliedOn', 'serviceLevel')">
              <app-checkbox [isChecked]="filter.appliedOn.serviceLevel"> </app-checkbox>
              {{ filterTitle.appliedOn.serviceLevel }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End stock -->
    
    <!-- Service Date Filter -->
    <div class="filter-pill date-filter" *ngIf="options.serviceDate">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true" [closeAfterAction]="closeAfterAction"
        right="-17%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper">
            <div class="icon">
              <i class="fal fa-calendar-alt"></i>
            </div>
            <div class="filter-text w-80px text-overflow-ellipsis"
              [ngClass]="{ active: filterApplied.serviceDate }">
              {{ filterTitle.serviceDate }}
            </div>
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.serviceDate"></i>
              <i class="fal fa-times" *ngIf="filterApplied.serviceDate"
                (click)="clearFilter('serviceDate')"></i>
            </div>
          </div>
        </ng-template>
    
        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-175">
            <div class="filter-option border-bottom-lightest" *ngFor="let filterOption of dateFilterOption"
              (click)="onStorageDateFilterSelect(filterOption.id,'serviceDate')"
              [ngClass]="{ 'active': filterApplied.serviceDate === filterOption.id }">
              {{filterOption.title}}
              <span *ngIf="filterOption.id === 'this-week' || filterOption.id === 'last-week'" class="week-days-label">(Mon
                - Sun)</span>
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    
    <!-- Start Agging -->
    <div class="filter-pill" *ngIf="options?.dayFilterOption">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-17%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper">
            <div class="icon">
              <i class="fal fa-calendar-alt"></i>
            </div>
            <div class="filter-text w-80px text-overflow-ellipsis"
              [ngClass]="{ active: filterApplied.dayFilterOption }">
              {{ filterTitle.dayFilterOption }}
            </div>
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.dayFilterOption"></i>
              <i class="fal fa-times" *ngIf="filterApplied.dayFilterOption"
                (click)="clearFilter('dayFilterOption')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <div class="filter-option border-bottom-lightest" *ngFor="let filterOption of dayFilterOption"
              (click)="onDateSelect(filterOption.id, 'date')">
              {{ filterOption.title }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Agging -->

    <!-- Start RO Invoice Date -->
    <div class="filter-pill" *ngIf="options?.invoiceDateFilterOption">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-17%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper">
            <div class="icon">
              <i class="fal fa-calendar-alt"></i>
            </div>
            <div class="filter-text w-110 text-overflow-ellipsis"
              [ngClass]="{ active: filterApplied.invoiceDateFilterOption }">
              <span *ngIf="filterApplied.invoiceDateFilterOption">INV - </span>
              {{ filterTitle.invoiceDateFilterOption }}
            </div>
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.invoiceDateFilterOption"></i>
              <i class="fal fa-times" *ngIf="filterApplied.invoiceDateFilterOption"
                (click)="clearFilter('invoiceDateFilterOption')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <div class="filter-option border-bottom-lightest" *ngFor="let filterOption of invoiceDateFilterOption"
              (click)="onDateSelect(filterOption.id, 'invoiceDateFilterOption')">
              {{ filterOption.title }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End RO Invoice Date -->

    <!-- Start Muliple invoice date -->
    <div class="filter-pill" *ngIf="options?.multiInvDate">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-13%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.multiInvDate }">
            <div class="icon">
              <i class="fal fa-calendar-alt"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis" [ngClass]="{'w-96px':isFastlapExtraOptions}">
              <span *ngIf="!filter?.multiInvDate?.selected?.length">{{ filterTitle?.multiInvDate?.all
                }}</span>
              <span *ngIf="filter?.multiInvDate?.selected?.length === 1">{{
                (filter?.multiInvDate?.selected)[0]?.name }}</span>
              <span *ngIf="filter?.multiInvDate?.selected?.length > 1">{{ filterTitle?.multiInvDate?.multiple
                }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.multiInvDate"></i>
              <i class="fal fa-times" *ngIf="filterApplied.multiInvDate" (click)="clearFilter('multiInvDate')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-180 text-overflow-ellipsis">
            <app-multiple-filter scrollHeight="265px" [data]="multiInvoiceDateFilterOption"
              (appChangeFilter)="changeMultiInvDateFilter($event)"> </app-multiple-filter>
            <div class=" flex-end-center p-2">
              <button class="btn btn-primary btn-submit" (click)="handleInvoiceDateFilter()">Apply</button>
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Muliple invoice date -->

    <!-- Start Muliple RO created date -->
    <div class="filter-pill" *ngIf="options?.multiROcreatedDate">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-13%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.multiROcreatedDate }">
            <div class="icon">
              <i class="fal fa-calendar-alt"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis" [ngClass]="{'w-96px':isFastlapExtraOptions}">
              <span *ngIf="!filter?.multiROcreatedDate?.selected?.length">{{ filterTitle?.multiROcreatedDate?.all
                }}</span>
              <span *ngIf="filter?.multiROcreatedDate?.selected?.length === 1">{{
                (filter?.multiROcreatedDate?.selected)[0]?.name }}</span>
              <span *ngIf="filter?.multiROcreatedDate?.selected?.length > 1">{{
                filterTitle?.multiROcreatedDate?.multiple
                }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.multiROcreatedDate"></i>
              <i class="fal fa-times" *ngIf="filterApplied.multiROcreatedDate"
                (click)="clearFilter('multiROcreatedDate')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-180 text-overflow-ellipsis">
            <app-multiple-filter scrollHeight="265px" [data]="multiRODateFilterOption"
              (appChangeFilter)="changeMultiRODateFilter($event)"> </app-multiple-filter>
            <div class=" flex-end-center p-2">
              <button class="btn btn-primary btn-submit" (click)="handleRODateFilter()">Apply</button>
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Muliple invoice date -->

    <!-- Start RO Created Date -->
    <div class="filter-pill" *ngIf="options?.roCreateAtFilterOption">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-17%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper">
            <div class="icon">
              <i class="fal fa-calendar-alt" [ngClass]="{ 'font-primary': filterApplied.roCreateAtFilterOption }"></i>
            </div>
            <div class="filter-text w-110 text-overflow-ellipsis"
              [ngClass]="{ 'font-primary': filterApplied.roCreateAtFilterOption }">
              <span *ngIf="filterApplied.roCreateAtFilterOption">RO - </span>
              {{ filterTitle.roCreateAtFilterOption }}
            </div>
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.roCreateAtFilterOption"></i>
              <i class="fal fa-times" *ngIf="filterApplied.roCreateAtFilterOption"
                (click)="clearFilter('roCreateAtFilterOption')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <div class="filter-option border-bottom-lightest" *ngFor="let filterOption of roCreateAtFilterOption"
              (click)="onDateSelect(filterOption.id, 'roCreateAtFilterOption')">
              {{ filterOption.title }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End RO Created Date -->

    <!-- Start Invoiced ROs multi radio buttons  -->
    <div class="filter-pill" *ngIf="options?.multiRangeInvDate">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-5%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.multiRangeInvDate }">
            <!-- Icon -->
            <div class="icon"><i class="fal fa-calendar-alt"></i></div>

            <!-- Title -->
            <div class="filter-text w-110px text-overflow-ellipsis">
              <span *ngIf="filterApplied.multiRangeInvDate; else noInvStatus">
                Last RO invoiced
              </span>
              <ng-template #noInvStatus>
                Last RO invoiced
              </ng-template>
            </div>

            <!-- Clear -->
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.multiRangeInvDate"></i>
              <i class="fal fa-times" *ngIf="filterApplied.multiRangeInvDate"
                (click)="clearFilter('multiRangeInvDate')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="text-overflow-ellipsis py-2 px-3" style="width:350px">
            <span class="font-bold font-14">Invoiced ROs created in past</span>
            <div class="d-flex pt-2 flex-between">
              <div class="filter-overlay w-140 multi-range-border">
                <span class="font-bold pb-2">Start Date</span>
                <app-single-filter nameField="name" valueField="id" name="multiRangeInvDate"
                  [selectedValue]="{ id: filter.multiRangeInvDate?.startDate?.id }"
                  [data]="multiRangeInvDateFilterOption.startDate" scrollHeight="500px"
                  (appChangeFilter)="changeMultInvRangeDateFilter($event, 'multiRangeInvDate', 'startDate')">
                </app-single-filter>
              </div>

              <div class="filter-overlay w-140 multi-range-border"
                [ngClass]="{'disabled': !filter.multiRangeInvDate?.startDate}">
                <span class="font-bold pb-2">End Date</span>
                <app-single-filter nameField="name" valueField="id" name="multiRangeInvDate"
                  [selectedValue]="{ id: filter.multiRangeInvDate?.endDate?.id }"
                  [data]="multiRangeInvDateFilterOption.endDate" scrollHeight="500px"
                  (appChangeFilter)="changeMultInvRangeDateFilter($event, 'multiRangeInvDate', 'endDate')">
                </app-single-filter>
              </div>
            </div>
            <div class=" flex-end-center p-2">
              <button class="btn btn-primary btn-submit" [ngClass]="{'not-allowed': !filter.multiRangeInvDate?.endDate}" [disabled]="!filter.multiRangeInvDate?.endDate" (click)="handleMultInvRangeDateFilter()">Apply</button>
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Invoiced ROs multi radio buttons -->

    <!-- Start ROs multi radio buttons  -->
    <div class="filter-pill" *ngIf="options?.multiRangeRODate">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-5%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.multiRangeRODate }">
            <!-- Icon -->
            <div class="icon"><i class="fal fa-calendar-alt"></i></div>

            <!-- Title -->
            <div class="filter-text w-110px text-overflow-ellipsis">
              <span *ngIf="filterApplied.multiRangeRODate; else noRoRange">
                Last RO created
              </span>
              <ng-template #noRoRange>
                Last RO created
              </ng-template>
            </div>

            <!-- Clear -->
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.multiRangeRODate"></i>
              <i class="fal fa-times" *ngIf="filterApplied.multiRangeRODate"
                (click)="clearFilter('multiRangeRODate')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="text-overflow-ellipsis py-2 px-3" style="width:350px">
            <span class="font-bold font-14">ROs created in past</span>
            <div class="d-flex pt-2 flex-between">
              <div class="filter-overlay w-140 multi-range-border">
                <span class="font-bold pb-2">Start Date</span>
                <app-single-filter nameField="name" valueField="id" name="multiRangeRODate"
                  [selectedValue]="{ id: filter.multiRangeRODate?.startDate?.id }"
                  [data]="multiRangeRODateFilterOption.startDate" scrollHeight="500px"
                  (appChangeFilter)="changeMultiRORangeDateFilter($event, 'multiRangeRODate', 'startDate')">
                </app-single-filter>
              </div>
              <div class="filter-overlay w-140 multi-range-border"
                [ngClass]="{'disabled': !filter.multiRangeRODate?.startDate}">
                <span class="font-bold pb-2">End Date</span>
                <app-single-filter nameField="name" valueField="id" name="multiRangeRODate"
                  [selectedValue]="{ id: filter.multiRangeRODate?.endDate?.id }"
                  [data]="multiRangeRODateFilterOption.endDate" scrollHeight="500px"
                  (appChangeFilter)="changeMultiRORangeDateFilter($event, 'multiRangeRODate', 'endDate')">
                </app-single-filter>
              </div>
            </div>
            <div class=" flex-end-center p-2">
              <button class="btn btn-primary btn-submit" [ngClass]="{'not-allowed': !filter.multiRangeRODate?.endDate}" [disabled]="!filter.multiRangeRODate?.endDate" (click)="handleMultiRORangeDateFilter()">Apply</button>
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End ROs multi radio buttons -->

    <!-- Start -->
    <div class="filter-pill" *ngIf="options?.categoryItemType">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-5%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.categoryItemType }">
            <!-- Title -->
            <div class="filter-text w-100px text-overflow-ellipsis">
              <span *ngIf="filterApplied.categoryItemType; else noPaymentStatus">
                {{(filterTitle?.categoryItemType)[filter?.categoryItemType]}}
              </span>
              <ng-template #noPaymentStatus>Category</ng-template>
            </div>

            <!-- Clear -->
            <div class="filter-cross">
              <i class="fal fa-chevron-down"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160 text-overflow-ellipsis">
            <app-single-filter nameField="label" valueField="value" name="categoryItemType" scrollHeight="260px"
              [selectedValue]="{ value: filter.categoryItemType }" [data]="categoryItemTypeDropDownList"
              (appChangeFilter)="changeTagFilter('categoryItemType', $event.value, false)">
            </app-single-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>

    <!-- Start PO status -->
    <div class="filter-pill" *ngIf="options?.poStatus">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-5%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.poStatus }">
            <!-- Icon -->
            <div class="icon"><i class="fal fa-truck"></i></div>

            <!-- Title -->
            <div class="filter-text w-100px text-overflow-ellipsis">
              <span *ngIf="filterApplied.poStatus; else noPOStatus">{{ (filterTitle?.poStatus)[filter?.poStatus]
                }}</span>
              <ng-template #noPOStatus>PO status</ng-template>
            </div>

            <!-- Clear -->
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.poStatus"></i>
              <i class="fal fa-times" *ngIf="filterApplied.poStatus" (click)="clearFilter('poStatus')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160 text-overflow-ellipsis">
            <app-single-filter nameField="label" valueField="value" name="poStatus" scrollHeight="260px"
              [selectedValue]="{ value: filter.poStatus }" [data]="purchaseOrderStatuses"
              (appChangeFilter)="changeTagFilter('poStatus', $event.value, false)">
            </app-single-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End PO status -->

    <!-- Start PO item type -->
    <div class="filter-pill" *ngIf="options?.poItemType">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-5%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.poItemType }">
            <!-- Icon -->
            <div class="icon"><i class="fal fa-truck"></i></div>

            <!-- Title -->
            <div class="filter-text w-100px text-overflow-ellipsis">
              <span *ngIf="filterApplied.poItemType; else noPOItemType">{{ (filterTitle?.poItemType)[filter?.poItemType]
                }}</span>
              <ng-template #noPOItemType>Type</ng-template>
            </div>

            <!-- Clear -->
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.poItemType"></i>
              <i class="fal fa-times" *ngIf="filterApplied.poItemType" (click)="clearFilter('poItemType')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160 text-overflow-ellipsis">
            <app-single-filter nameField="label" valueField="value" name="poItemType" scrollHeight="260px"
              [selectedValue]="{ value: filter.poItemType }" [data]="purchaseOrderItemTypes"
              (appChangeFilter)="changeTagFilter('poItemType', $event.value, false)">
            </app-single-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End PO item type -->

    <!-- Start Core Return Status -->
    <div class="filter-pill coreReturnStatus" *ngIf="options?.returnStatus">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-5%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.returnStatus }">
            <!-- Icon -->
            <div class="icon"><i class="fal fa-steering-wheel"></i></div>

            <!-- Title -->
            <div class="filter-text w-100px text-overflow-ellipsis">
              <span *ngIf="filter?.returnStatus?.selected?.length === 0">Return status</span>
              <span *ngIf="filter?.returnStatus?.selected?.length === 1">{{ (filter?.returnStatus?.selected)[0]?.name
                }}</span>
              <span *ngIf="filter?.returnStatus?.selected?.length > 1">{{ filterTitle?.returnStatusList?.multiple
                }}</span>
            </div>

            <!-- Clear -->
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.returnStatus"></i>
              <i class="fal fa-times" *ngIf="filterApplied.returnStatus" (click)="clearFilter('returnStatus')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-180 text-overflow-ellipsis">
            <app-multiple-filter scrollHeight="265px" nameField="name" [data]="returnList"
              (appChangeFilter)="changeTagFilter('returnStatus', $event, true)"> </app-multiple-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Core Return Status -->

    <!-- Start Core Status -->
    <div class="filter-pill coreReturnStatus" *ngIf="options?.coreStatus">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-5%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.coreStatus }">
            <!-- Icon -->
            <div class="icon"><i class="fal fa-starship-freighter"></i></div>

            <!-- Title -->
            <div class="filter-text w-100px text-overflow-ellipsis">
              <span *ngIf="filter?.coreStatus?.selected?.length === 0">Core status</span>
              <span *ngIf="filter?.coreStatus?.selected?.length === 1">{{ (filter?.coreStatus?.selected)[0]?.name
                }}</span>
              <span *ngIf="filter?.coreStatus?.selected?.length > 1">{{ filterTitle?.coreStatusList?.multiple }}</span>
            </div>

            <!-- Clear -->
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.coreStatus"></i>
              <i class="fal fa-times" *ngIf="filterApplied.coreStatus" (click)="clearFilter('coreStatus')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-180 text-overflow-ellipsis">
            <app-multiple-filter scrollHeight="265px" nameField="name" [data]="coreList"
              (appChangeFilter)="changeTagFilter('coreStatus', $event, true)"> </app-multiple-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Core  Status -->

    <!-- Start supplier -->
    <div class="filter-pill" *ngIf="options?.supplier">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true" [closeAfterAction]="false"
        right="-5%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.supplier }">
            <!-- Icon -->
            <div class="icon"><i class="fal" [ngClass]="isCoreSuppliers? 'fa-building' : 'fa-warehouse'"></i></div>

            <!-- Title -->
            <div class="filter-text w-100px text-overflow-ellipsis">
              <span *ngIf="filter?.supplier?.selected?.length === 0">Supplier</span>
              <span *ngIf="filter?.supplier?.selected?.length === 1">{{ (filter?.supplier?.selected)[0]?.name }}</span>
              <span *ngIf="filter?.supplier?.selected?.length > 1">{{ filterTitle?.supplier?.multiple }}</span>
            </div>

            <!-- Clear -->
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.supplier"></i>
              <i class="fal fa-times" *ngIf="filterApplied.supplier" (click)="clearFilter('supplier')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-180 text-overflow-ellipsis">
            <app-multiple-filter scrollHeight="265px" nameField="name" [data]="suppliers" [listData]="suppliers"
              [isSearchSelect]="true" (appChangeFilter)="changeTagFilter('supplier', $event, true)">
            </app-multiple-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End supplier -->

    <!-- Start Generic Filter -->
    <div class="filter-pill" *ngIf="options.genericFilter">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="0%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.genericFilter }">
            <!-- Icon -->
            <div class="icon"><i class="fal" [ngClass]="genericFilterOptions?.iconClass"></i></div>

            <!-- Title -->
            <div class="text-overflow-ellipsis" [ngStyle]="genericFilterOptions?.styleCss">
              <span *ngIf="filter?.genericFilter?.selected?.length === 0">{{genericFilterOptions?.selectAllText}}</span>
              <span *ngIf="filter?.genericFilter?.selected?.length === 1">{{
                (filter?.genericFilter?.selected)[0][genericFilterOptions?.nameField] }}</span>
              <span *ngIf="filter?.genericFilter?.selected?.length > 1">{{ genericFilterOptions?.multipleSelectText ?
                genericFilterOptions?.multipleSelectText : 'Multiple Select' }}</span>
            </div>

            <!-- Clear -->
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.genericFilter"></i>
              <i class="fal fa-times" *ngIf="filterApplied.genericFilter" (click)="clearFilter('genericFilter')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay text-overflow-ellipsis" [ngStyle]="genericFilterOptions?.filterOverlayStyle">
            <app-multiple-filter scrollHeight="265px" [nameField]="genericFilterOptions?.nameField"
              [data]="genericFilterData" (appChangeFilter)="changeTagFilter('genericFilter', $event, true)">
            </app-multiple-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>

    <!-- Start of multiple generic filter -->
    <ng-container *ngIf="options.multipleGenericFilters">
      <div class="filter-pill" *ngFor="let filterKey of multipleGenericFiltersKeys"
        [ngStyle]="multipleGenericFiltersObject[filterKey]?.filterOptions?.width ? {width: multipleGenericFiltersObject[filterKey]?.filterOptions?.width} : ''">
        <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
          [closeAfterAction]="closeAfterAction" right="0%">
          <ng-template appTemplate="item">
            <div class="filter-pill-inner-wrapper"
              [ngClass]="{ active: multipleGenericFiltersObject[filterKey]?.filterApplied }">
              <!-- Icon -->
              <div *ngIf="!multipleGenericFiltersObject[filterKey]?.filterOptions?.isIconImage" class="icon"><i class="fal"
                  [ngClass]="multipleGenericFiltersObject[filterKey]?.filterOptions?.iconClass"></i></div>
                  <div *ngIf="multipleGenericFiltersObject[filterKey]?.filterOptions?.isIconImage" class="icon">
                    <img src="{{multipleGenericFiltersObject[filterKey]?.filterOptions?.iconClass}}" alt="$"></div>

              <!-- Title -->
              <div class="text-overflow-ellipsis"
                [ngStyle]="multipleGenericFiltersObject[filterKey]?.filterOptions?.styleCss">
                <span
                  *ngIf="multipleGenericFiltersObject[filterKey]?.selected?.length === 0">{{multipleGenericFiltersObject[filterKey]?.filterOptions?.selectAllText}}</span>
                <span *ngIf="multipleGenericFiltersObject[filterKey]?.selected?.length === 1">{{
                  (multipleGenericFiltersObject[filterKey]?.selected)[0][multipleGenericFiltersObject[filterKey].filterOptions?.labelFieldToShowAsSelected
                  || multipleGenericFiltersObject[filterKey].filterOptions?.nameField]
                  }}</span>
                <span *ngIf="multipleGenericFiltersObject[filterKey]?.selected?.length > 1">{{
                  multipleGenericFiltersObject[filterKey]?.filterOptions?.multipleSelectText ?
                  multipleGenericFiltersObject[filterKey]?.filterOptions?.multipleSelectText : 'Multiple Select'
                  }}</span>
              </div>

              <!-- Clear -->
              <div class="filter-cross">
                <i class="fal fa-chevron-down"
                  *ngIf="!multipleGenericFiltersObject[filterKey]?.filterApplied || multipleGenericFiltersObject[filterKey]?.hideCross"></i>
                <i class="fal fa-times"
                  *ngIf="multipleGenericFiltersObject[filterKey]?.filterApplied && !multipleGenericFiltersObject[filterKey]?.hideCross"
                  (click)="clearMultipleGenericFilter(filterKey)"></i>
              </div>
            </div>
          </ng-template>

          <ng-template appTemplate="overlay">
            <div *ngIf="!multipleGenericFiltersObject[filterKey]?.filterOptions?.isSingleSelect"
              class="filter-overlay text-overflow-ellipsis"
              [ngStyle]="multipleGenericFiltersObject[filterKey]?.filterOptions?.filterOverlayStyle">
              <app-multiple-filter scrollHeight="265px"
                [nameField]="multipleGenericFiltersObject[filterKey]?.filterOptions?.nameField"
                [multipleFilterData]="multipleGenericFiltersObject[filterKey]?.data"
                [multipleSearchPlaceholders]="multipleGenericFiltersObject[filterKey]?.searchFilterObj || {}"
                [isSearchSelect]="multipleGenericFiltersObject[filterKey]?.searchFilterObj?.isSearchEnable || false"
                [multipleFilterListData]="multipleGenericFiltersObject[filterKey]?.data"
                (appChangeFilter)="changeMultipleGenericFilter(filterKey, $event)"> </app-multiple-filter>
            </div>
            <div *ngIf="multipleGenericFiltersObject[filterKey]?.filterOptions?.isSingleSelect"
              class="filter-overlay text-overflow-ellipsis"
              [ngStyle]="multipleGenericFiltersObject[filterKey]?.filterOptions?.filterOverlayStyle">
              <app-single-filter scrollHeight="265px"
                [nameField]="multipleGenericFiltersObject[filterKey]?.filterOptions?.nameField"
                [valueField]="multipleGenericFiltersObject[filterKey]?.filterOptions?.valueField"
                [selectedValue]="multipleGenericFiltersObject[filterKey]?.selected?.length > 0 ? multipleGenericFiltersObject[filterKey].selected[0] : {}"
                [data]="multipleGenericFiltersObject[filterKey]?.data"
                [searchFilter]="multipleGenericFiltersObject[filterKey]?.searchFilterObj"
                [listData]="multipleGenericFiltersObject[filterKey]?.data"
                (appChangeFilter)="changeMultipleGenericFilter(filterKey, $event, false)">
              </app-single-filter>
            </div>
          </ng-template>
        </app-content-overlay>
      </div>
    </ng-container>
    <!-- End of generic multiple filter -->
    <!-- End activity logs -->

    <!-- PAYABLE STATUS -->
    <!-- Start -->
    <div class="filter-pill" *ngIf="options?.payableStatus">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-5%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.payableStatus }">
            <!-- Icon -->
            <div class="icon"><i class="fal fa-truck"></i></div>

            <!-- Title -->
            <div class="filter-text w-100px text-overflow-ellipsis">
              <span *ngIf="filterApplied.payableStatus; else noPayableStatus">{{
                (filterTitle?.payableStatus)[filter?.payableStatus]
                }}</span>
              <ng-template #noPayableStatus>Payable status</ng-template>
            </div>

            <!-- Clear -->
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.payableStatus"></i>
              <i class="fal fa-times" *ngIf="filterApplied.payableStatus" (click)="clearFilter('payableStatus')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160 text-overflow-ellipsis">
            <app-single-filter nameField="label" valueField="value" name="payableStatus" scrollHeight="260px"
              [selectedValue]="{ value: filter.payableStatus }" [data]="payableStatusDropDownList"
              (appChangeFilter)="changeTagFilter('payableStatus', $event.value, false)">
            </app-single-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Payable  Status -->

    <!-- paymentPayableStatus start-->
    <div class="filter-pill" *ngIf="options?.paymentPayableStatus">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-5%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.paymentPayableStatus }">
            <!-- Icon -->
            <div class="icon"><i class="fal fa-truck"></i></div>

            <!-- Title -->
            <div class="filter-text w-100px text-overflow-ellipsis">
              <span *ngIf="filterApplied.paymentPayableStatus; else nopaymentPayableStatus">{{
                (filterTitle?.paymentPayableStatus)[filter?.paymentPayableStatus] }}</span>
              <ng-template #nopaymentPayableStatus>Status</ng-template>
            </div>

            <!-- Clear -->
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.paymentPayableStatus"></i>
              <i class="fal fa-times" *ngIf="filterApplied.paymentPayableStatus"
                (click)="clearFilter('paymentPayableStatus')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160 text-overflow-ellipsis">
            <app-single-filter nameField="label" valueField="value" name="paymentPayableStatus" scrollHeight="260px"
              [selectedValue]="{ value: filter.paymentPayableStatus }" [data]="paymentPayableStatusDropDownList"
              (appChangeFilter)="changeTagFilter('paymentPayableStatus', $event.value, false)">
            </app-single-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- paymentPayableStatus end-->

    <!-- PAYMENT STATUS -->
    <!-- Start -->
    <div class="filter-pill" *ngIf="options?.paymentStatus">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-5%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.paymentStatus }">
            <!-- Icon -->
            <div class="icon"><i class="fal fa-truck"></i></div>

            <!-- Title -->
            <div class="filter-text w-100px text-overflow-ellipsis">
              <span *ngIf="filterApplied.paymentStatus; else noPaymentStatus">{{
                (filterTitle?.paymentStatus)[filter?.paymentStatus]
                }}</span>
              <ng-template #noPaymentStatus>Payment status</ng-template>
            </div>

            <!-- Clear -->
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.paymentStatus"></i>
              <i class="fal fa-times" *ngIf="filterApplied.paymentStatus" (click)="clearFilter('paymentStatus')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160 text-overflow-ellipsis">
            <app-single-filter nameField="label" valueField="value" name="paymentStatus" scrollHeight="260px"
              [selectedValue]="{ value: filter.paymentStatus }" [data]="paymentStatusDropDownList"
              (appChangeFilter)="changeTagFilter('paymentStatus', $event.value, false)">
            </app-single-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End PAYMENT Status -->

    <!-- Product type -->
    <!-- Start -->
    <div class="filter-pill" *ngIf="options?.itemType">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-5%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.itemType }">
            <!-- Icon -->
            <div class="icon"><i class="fal fa-filter"></i></div>

            <!-- Title -->
            <div class="filter-text w-100px text-overflow-ellipsis">
              <span *ngIf="filterApplied.itemType; else noPaymentStatus">{{ (filterTitle?.itemType)[filter?.itemType]
                }}</span>
              <ng-template #noPaymentStatus>Item</ng-template>
            </div>

            <!-- Clear -->
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.itemType"></i>
              <i class="fal fa-times" *ngIf="filterApplied.itemType" (click)="clearFilter('itemType')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160 text-overflow-ellipsis">
            <app-single-filter nameField="label" valueField="value" name="itemType" scrollHeight="260px"
              [selectedValue]="{ value: filter.itemType }" [data]="itemTypeDropDownList"
              (appChangeFilter)="changeTagFilter('itemType', $event.value, false)">
            </app-single-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Product type -->

    <!-- Product type -->
    <!-- Start -->
    <div class="filter-pill item-type" *ngIf="options?.categoryType">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true" [disabled]="true"
        [closeAfterAction]="closeAfterAction" right="-5%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.categoryType }">
            <!-- Icon -->
            <div class="icon"></div>

            <!-- Title -->
            <div class="filter-text w-100px text-overflow-ellipsis">
              <span *ngIf="filterApplied.categoryType; else noPaymentStatus">{{
                (filterTitle?.categoryType)[filter?.categoryType]
                }}</span>
              <ng-template #noPaymentStatus>Item</ng-template>
            </div>

            <!-- Clear -->
            <div class="filter-cross">
              <i class="fal fa-chevron-down"></i>
              <!-- <i class="fal fa-times" *ngIf="filterApplied.categoryType" (click)="clearFilter('categoryType')"></i> -->
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160 text-overflow-ellipsis">
            <app-single-filter nameField="label" valueField="value" name="categoryType" scrollHeight="260px"
              [selectedValue]="{ value: filter.categoryType }"
              (appChangeFilter)="changeTagFilter('categoryType', $event.value, false)">
            </app-single-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Product type -->

    <!-- Start Tags -->
    <div class="filter-pill" *ngIf="options?.tags">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-13%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.tags }">
            <div class="icon">
              <i class="fal fa-tags"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis">
              <span *ngIf="filter?.tags?.selected?.length === 0">{{ filterTitle?.tags?.all }}</span>
              <span *ngIf="filter?.tags?.selected?.length === 1">{{ (filter?.tags?.selected)[0]?.name }}</span>
              <span *ngIf="filter?.tags?.selected?.length > 1">{{ filterTitle?.tags?.multiple }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.tags"></i>
              <i class="fal fa-times" *ngIf="filterApplied.tags" (click)="clearFilter('tags')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-180 text-overflow-ellipsis">
            <app-multiple-filter scrollHeight="265px" [data]="tags"
              (appChangeFilter)="changeTagFilter('tags', $event, true)"> </app-multiple-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Tags -->

    <!-- Authorization -->
    <div *ngIf="options.authorization" class="filter-pill authorization-filter">
      <app-content-overlay right="7%" [dropshadow]="true" [showArrow]="true" [closeAfterAction]="closeAfterAction">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.authorization }">
            <!-- Icon -->
            <div class="icon"><i class="fal fa-clipboard-check"></i></div>

            <!-- Title -->
            <div class="filter-text w-100px text-overflow-ellipsis">
              <span
                *ngIf="(filter?.authorization?.approved && filter?.authorization?.notApproved) || (!filter?.authorization?.approved && !filter?.authorization?.notApproved)">
                {{ filterTitle?.authorization?.all }}
              </span>

              <span *ngIf="filter?.authorization?.approved && !filter?.authorization?.notApproved">
                {{ filterTitle?.authorization?.approved }}
              </span>

              <span *ngIf="!filter?.authorization?.approved && filter?.authorization?.notApproved">
                {{ filterTitle?.authorization?.notApproved }}
              </span>
            </div>

            <!-- Clear -->
            <div class="filter-cross">
              <i *ngIf="!filterApplied?.authorization" class="fal fa-chevron-down"></i>
              <i *ngIf="filterApplied?.authorization" class="fal fa-times" (click)="clearFilter('authorization')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-120">
            <div class="filter-option border-bottom-lightest" (click)="onChange('authorization', 'approved')">
              <app-checkbox [isChecked]="filter?.authorization?.approved"> </app-checkbox>
              {{ filterTitle?.authorization?.approved }}
            </div>

            <div class="filter-option border-bottom-lightest" (click)="onChange('authorization', 'notApproved')">
              <app-checkbox [isChecked]="filter?.authorization?.notApproved"> </app-checkbox>
              {{ filterTitle?.authorization?.notApproved }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>

    <!-- Start Tenants Feature -->
    <div class="filter-pill" *ngIf="options?.tenantFeature">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-13%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.tenantFeature }">
            <div class="icon">
              <i class="fal fa-window"></i>
            </div>

            <div class="filter-text w-140 text-overflow-ellipsis">
              <!-- featureList -->
              <span *ngIf="featureFilter?.tenantFeature?.selected?.length === featureList.length">{{
                filterTitle?.tenantFeature?.allSelected
                }}</span>
              <span *ngIf="featureFilter?.tenantFeature?.selected?.length === 0">{{ filterTitle?.tenantFeature?.all
                }}</span>
              <span *ngIf="featureFilter?.tenantFeature?.selected?.length === 1">{{
                (featureFilter?.tenantFeature?.selected)[0]?.name }}</span>
              <span
                *ngIf="featureFilter?.tenantFeature?.selected?.length > 1 && featureFilter?.tenantFeature?.selected?.length !== featureList?.length">{{
                filterTitle?.tenantFeature?.multiple
                }}</span>
            </div>
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.tenantFeature"></i>
              <i class="fal fa-times" *ngIf="filterApplied.tenantFeature" (click)="clearFilter('tenantFeature')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-260 text-overflow-ellipsis">
            <app-multiple-filter scrollHeight="265px" [data]="tenantFeature" [grayCheckbox]="true"
              [childData]="childData" (appChangeFilter)="changeTenantFeatureFilter('tenantFeature', $event, true)">
            </app-multiple-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Tenants Feature -->

    <!-- Start Beta flag tenants feature -->
    <div class="filter-pill" *ngIf="options?.tenantBetaFlagFeature">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-3%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.tenantBetaFlagFeature }">
            <div class="icon">
              <i class="fal fa-window"></i>
            </div>
            <!-- betaList -->
            <div class="filter-text w-140 text-overflow-ellipsis">
              <span *ngIf="featureFilter?.tenantBetaFlagFeature?.selected?.length === betaList.length">{{
                filterTitle?.tenantBetaFlagFeature?.allSelected
                }}</span>
              <span *ngIf="featureFilter?.tenantBetaFlagFeature?.selected?.length === 0">{{
                filterTitle?.tenantBetaFlagFeature?.all
                }}</span>
              <span *ngIf="featureFilter?.tenantBetaFlagFeature?.selected?.length === 1">{{
                (featureFilter?.tenantBetaFlagFeature?.selected)[0]?.name }}</span>
              <span *ngIf="featureFilter?.tenantBetaFlagFeature?.selected?.length > 1 &&
                featureFilter?.tenantBetaFlagFeature?.selected?.length !== betaList.length">{{
                filterTitle?.tenantBetaFlagFeature?.multiple
                }}</span>
            </div>
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.tenantBetaFlagFeature"></i>
              <i class="fal fa-times" *ngIf="filterApplied.tenantBetaFlagFeature"
                (click)="clearFilter('tenantBetaFlagFeature')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-260 text-overflow-ellipsis">
            <app-multiple-filter scrollHeight="265px" [data]="tenantBetaFlagFeature" [grayCheckbox]="true"
              (appChangeFilter)="changeTenantBetaFeatureFilter('tenantBetaFlagFeature', $event, true)">
            </app-multiple-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!--  END Beta flag tenants feature -->

    <!-- Tenant Status  -->
    <div class="filter-pill quantity" *ngIf="options.tenantStatus">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-3%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.tenantStatus }">
            <div class="icon">
              <i class="fal fa-clipboard"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis">
              <span> {{ getTenantStatusTitle() }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.tenantStatus"></i>
              <i class="fal fa-times" *ngIf="filterApplied.tenantStatus" (click)="clearFilter('tenantStatus')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <div *ngFor="let key of getFilterKeys('tenantStatus')" class="filter-option border-bottom-lightest"
              (click)="onChangeTenantStatus('tenantStatus', key)">
              <app-checkbox [isChecked]="featureFilter.tenantStatus[key]" [grayCheckbox]="true"> </app-checkbox>
              {{ filterTitle.tenantStatus[key] }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Tenant Status -->

    <!-- Tenant Status  -->
    <div class="filter-pill quantity" *ngIf="options.tenantFlagStatus">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-3%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.tenantFlagStatus }">
            <div class="icon">
              <i class="fal fa-filter"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis">
              <span> {{ getTenantFlagStatusTitle() }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.tenantFlagStatus"></i>
              <i class="fal fa-times" *ngIf="filterApplied.tenantFlagStatus"
                (click)="clearFilter('tenantFlagStatus')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <div *ngFor="let key of getFilterKeys('tenantFlagStatus')" class="filter-option border-bottom-lightest"
              (click)="onChangeTenantFlagStatus('tenantFlagStatus', key)">
              <app-checkbox [isChecked]="featureFilter.tenantFlagStatus[key]" [grayCheckbox]="true"> </app-checkbox>
              {{ filterTitle.tenantFlagStatus[key] }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Tenant Status -->

    <!-- Start Tenant Type -->
    <div class="filter-pill quantity" *ngIf="options.tenantType">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-3%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.tenantType }">
            <div class="icon">
              <i class="fal fa-store-alt"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis">
              <span> {{ getTenantTypeTitle() }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.tenantType"></i>
              <i class="fal fa-times" *ngIf="filterApplied.tenantType" (click)="clearFilter('tenantType')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-160">
            <div *ngFor="let key of getFilterKeys('tenantType')" class="filter-option border-bottom-lightest"
              (click)="onChangeTenantType('tenantType', key)">
              <app-checkbox [isChecked]="featureFilter.tenantType[key]" [grayCheckbox]="true"> </app-checkbox>
              {{ filterTitle.tenantType[key] }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Tenant Type -->

    <!-- Start Tire Storage Status -->
    <div class="filter-pill" *ngIf="options?.tireStoragestatus">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-4%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied?.tireStoragestatus }">
            <div class="icon">
              <i class="fal fa-boxes"></i>
            </div>

            <div class="filter-text w-87px text-overflow-ellipsis">
              <span *ngIf="filter?.tireStoragestatus?.inStorage && filter?.tireStoragestatus?.returned">
                {{ filterTitle?.tireStoragestatus?.all }}
              </span>

              <span *ngIf="filter?.tireStoragestatus?.inStorage && !filter?.tireStoragestatus?.returned">
                {{ filterTitle?.tireStoragestatus?.inStorage }}
              </span>

              <span *ngIf="!filter?.tireStoragestatus?.inStorage && filter?.tireStoragestatus?.returned">
                {{ filterTitle?.tireStoragestatus?.returned }}
              </span>

              <span
                *ngIf="filter?.tireStoragestatus?.inStorage === false && filter?.tireStoragestatus?.returned === false">
                {{ filterTitle?.tireStoragestatus?.all }}
              </span>
            </div>
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied?.tireStoragestatus"></i>
              <i class="fal fa-times" *ngIf="filterApplied?.tireStoragestatus"
                (click)="clearFilter('tireStoragestatus')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-152">
            <div class="filter-option border-bottom-lightest" (click)="onChange('tireStoragestatus', 'inStorage')">
              <app-checkbox [isChecked]="filter?.tireStoragestatus?.inStorage"> </app-checkbox>
              {{ filterTitle.tireStoragestatus?.inStorage }}
            </div>

            <div class="filter-option border-bottom-lightest" (click)="onChange('tireStoragestatus', 'returned')">
              <app-checkbox [isChecked]="filter?.tireStoragestatus?.returned"> </app-checkbox>
              {{ filterTitle?.tireStoragestatus?.returned }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Tire Storage Status -->

    <!-- Start Tire In Storage Tab Status -->
    <div class="filter-pill" *ngIf="options?.tireStorageFilterStatus">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-4%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied?.tireStorageFilterStatus }">
            <div class="icon">
              <i class="fal fa-boxes"></i>
            </div>

            <div class="filter-text w-87px text-overflow-ellipsis">
              <span *ngIf="filter?.tireStorageFilterStatus?.inStorage && filter?.tireStorageFilterStatus?.removed">
                {{ filterTitle?.tireStorageFilterStatus?.all }}
              </span>

              <span *ngIf="filter?.tireStorageFilterStatus?.inStorage && !filter?.tireStorageFilterStatus?.removed">
                {{ filterTitle?.tireStorageFilterStatus?.inStorage }}
              </span>

              <span *ngIf="!filter?.tireStorageFilterStatus?.inStorage && filter?.tireStorageFilterStatus?.removed">
                {{ filterTitle?.tireStorageFilterStatus?.removed }}
              </span>

              <span
                *ngIf="filter?.tireStorageFilterStatus?.inStorage === false && filter?.tireStorageFilterStatus?.removed === false">
                {{ filterTitle?.tireStorageFilterStatus?.all }}
              </span>
            </div>
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied?.tireStorageFilterStatus"></i>
              <i class="fal fa-times" *ngIf="filterApplied?.tireStorageFilterStatus"
                (click)="clearFilter('tireStorageFilterStatus')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-152">
            <div class="filter-option border-bottom-lightest" (click)="onChange('tireStorageFilterStatus', 'inStorage')">
              <app-checkbox [isChecked]="filter?.tireStorageFilterStatus?.inStorage"> </app-checkbox>
              {{ filterTitle.tireStorageFilterStatus?.inStorage }}
            </div>

            <div class="filter-option border-bottom-lightest" (click)="onChange('tireStorageFilterStatus', 'removed')">
              <app-checkbox [isChecked]="filter?.tireStorageFilterStatus?.removed"> </app-checkbox>
              {{ filterTitle?.tireStorageFilterStatus?.removed }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Tire In Storage Tab Filter Status -->
    
    <!-- Start Tire Seasonality -->
    <div class="filter-pill" *ngIf="options?.tireStorageSeasonality">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-4%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied?.tireStorageSeasonality }">
            <div class="icon">
              <i class="far fa-sun"></i>
            </div>

            <div class="filter-text w-87px text-overflow-ellipsis">
              <span *ngIf="filter?.tireStorageSeasonality?.summer && filter?.tireStorageSeasonality?.winter">
                {{ filterTitle?.tireStorageSeasonality?.all }}
              </span>

              <span *ngIf="filter?.tireStorageSeasonality?.summer && !filter?.tireStorageSeasonality?.winter">
                {{ filterTitle?.tireStorageSeasonality?.summer }}
              </span>

              <span *ngIf="!filter?.tireStorageSeasonality?.summer && filter?.tireStorageSeasonality?.winter">
                {{ filterTitle?.tireStorageSeasonality?.winter }}
              </span>

              <span
                *ngIf="filter?.tireStorageSeasonality?.summer === false && filter?.tireStorageSeasonality?.winter === false">
                {{ filterTitle?.tireStorageSeasonality?.all }}
              </span>
            </div>
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied?.tireStorageSeasonality"></i>
              <i class="fal fa-times" *ngIf="filterApplied?.tireStorageSeasonality"
                (click)="clearFilter('tireStorageSeasonality')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-152">
            <div class="filter-option border-bottom-lightest" (click)="onChange('tireStorageSeasonality', 'summer')">
              <app-checkbox [isChecked]="filter?.tireStorageSeasonality?.summer"> </app-checkbox>
              {{ filterTitle.tireStorageSeasonality?.summer }}
            </div>

            <div class="filter-option border-bottom-lightest" (click)="onChange('tireStorageSeasonality', 'winter')">
              <app-checkbox [isChecked]="filter?.tireStorageSeasonality?.winter"> </app-checkbox>
              {{ filterTitle?.tireStorageSeasonality?.winter }}
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Seasonality -->

    <!-- Start removal date -->
    <div class="filter-pill date-filter" *ngIf="options.removalDateOption">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="1%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper">
            <div class="icon">
              <i class="fal fa-calendar-alt"></i>
            </div>
            <div class="filter-text w-150px text-overflow-ellipsis">
              Return date - {{filterTitle.removalDateOption}}
            </div>
            <!-- <div class="filter-text text-overflow-ellipsis w-150px" *ngIf="isTireStorage2Enabled">
              {{filterTitle.removalDateOption}}
            </div> -->
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-175">
            <div class="filter-option border-bottom-lightest" *ngFor="let filterOption of dateFilterOption"
              (click)="onStorageDateFilterSelect(filterOption.id,'removalDateOption')"
              [ngClass]="{'active': filterApplied.removalDateOption === filterOption.id }">
              {{filterOption.title}}
              <span *ngIf="filterOption.id === 'this-week' || filterOption.id === 'last-week'"
                class="week-days-label">(Mon - Sun)</span>
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>

    <!-- <div class="report-filter-date start-date-filter" *ngIf="options.removalDateOption">
      <div class="ml-1 storage-date mr-2">
        <p class="m-0" >
          <span class="font-11">Filter by:</span>
          <span class="font-11 font-gray-35 pl-1 font-600">{{ 'Return Date' }}</span>
        </p>
        <div class="flex-center-center font-gray-35 font-11 font-600">
          <span class="title">({{ filter['removalDateOption'].dateTitle }})</span>
        </div>
      </div>
    </div> -->
    <!-- End removal date -->
    

    <!-- Start Storage Date Filter -->
    <div class="filter-pill date-filter" *ngIf="options.storageDateOption">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="1%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper">
            <div class="icon">
              <i class="fal fa-calendar-alt"></i>
            </div>
            <div class="filter-text text-overflow-ellipsis w-150px">
              Storage date - {{filterTitle.storageDateOption}}
            </div>
            <!-- <div class="filter-text text-overflow-ellipsis w-150px" *ngIf="isTireStorage2Enabled">
              {{filterTitle.storageDateOption}}
            </div> -->
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-175">
            <div class="filter-option border-bottom-lightest" *ngFor="let filterOption of dateFilterOption"
              (click)="onStorageDateFilterSelect(filterOption.id,'storageDateOption')"
              [ngClass]="{ 'active': filterApplied.storageDateOption === filterOption.id }">
              {{filterOption.title}}
              <span *ngIf="filterOption.id === 'this-week' || filterOption.id === 'last-week'"
                class="week-days-label">(Mon - Sun)</span>
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>

    <!-- <div class="report-filter-date start-date-filter" *ngIf="options.storageDateOption">
      <div class="ml-1 storage-date mr-2">
        <p class="m-0" >
          <span class="font-11">Filter by:</span>
          <span class="font-11 font-gray-35 pl-1 font-600">{{ 'Storage Date' }}</span>
        </p>
        <div class="flex-center-center font-gray-35 font-11 font-600">
          <span class="title">({{ filter['storageDateOption'].dateTitle }})</span>
        </div>
      </div>
    </div> -->

    <!-- Start Scheduled Date Filter -->
     <!-- Start Date Filter -->
    <div class="filter-pill date-filter" *ngIf="options.scheduledReturnDateOption">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="1%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper">
            <div class="icon">
              <i class="fal fa-calendar-alt"></i>
            </div>
            <div class="filter-text text-overflow-ellipsis w-150px">
              Schedule date - {{filterTitle.scheduledReturnDateOption}}
            </div>
            <!-- <div class="filter-text text-overflow-ellipsis w-150px" *ngIf="isTireStorage2Enabled">
              {{filterTitle.scheduledReturnDateOption}}
            </div> -->
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-175">
            <div class="filter-option border-bottom-lightest" *ngFor="let filterOption of dateFilterOption"
              (click)="onStorageDateFilterSelect(filterOption.id,'scheduledReturnDateOption')"
              [ngClass]="{ 'active': filterApplied.scheduledReturnDateOption === filterOption.id }">
              {{filterOption.title}}
              <span *ngIf="filterOption.id === 'this-week' || filterOption.id === 'last-week'"
                class="week-days-label">(Mon - Sun)</span>
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>

    <!-- <div class="report-filter-date start-date-filter" *ngIf="options.scheduledReturnDateOption">
      <div class="ml-1 storage-date mr-2">
        <p class="m-0" >
          <span class="font-11">Filter by:</span>
          <span class="font-11 font-gray-35 pl-1 font-600">{{ 'Scheduled Returns' }}</span>
        </p>
        <div class="flex-center-center font-gray-35 font-11 font-600">
          <span class="title">({{ filter['scheduledReturnDateOption'].dateTitle }})</span>
        </div>
      </div>
    </div> -->

    <!-- Start Preferred Location -->
    <div class="filter-pill" *ngIf="options?.preffLocations">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true" [closeAfterAction]="false"
        right="-13%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.preffLocations }">
            <div class="icon">
              <i class="fal fa-store-alt"></i>
            </div>

            <div class="filter-text w-90px text-overflow-ellipsis">
              <span *ngIf="filter?.preffLocations?.selected?.length === 0">{{ filterTitle?.preffLocations?.all }}</span>
              <span *ngIf="filter?.preffLocations?.selected?.length === 1">{{
                (filter?.preffLocations?.selected)[0]?.name }}</span>
              <span *ngIf="filter?.preffLocations?.selected?.length > 1">{{ filterTitle?.preffLocations?.multiple
                }}</span>
            </div>

            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied.preffLocations"></i>
              <i class="fal fa-times" *ngIf="filterApplied.preffLocations" (click)="clearFilter('preffLocations')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-180 text-overflow-ellipsis">
            <app-multiple-filter scrollHeight="265px" [data]="selectAllPrefLocation"
              (appChangeFilter)="changePreffredLocationsFilter($event ,selectAllPrefLocation[0])">
            </app-multiple-filter>
            <app-multiple-filter scrollHeight="265px" [data]="preffLocations"
              (appChangeFilter)="changePreffredLocationsFilter($event ,preffLocations)"> </app-multiple-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End Preferred Location -->
  </div>

  <div class="report-filter-inner">
    <div class="report-export" *ngIf="hasPrint">
      <button class="btn btn-submit flex-center-center print-btn  print-btn-with-exp">
        <span (click)="print()"><i class="fal fa-print mr-1"></i>Print to PDF</span>
      </button>
    </div>
  </div>
</div>
